import React, { Component } from 'react'
import { changePassword, sellerContext } from '../../services/User';
import Formsy from 'formsy-react'
import { Grid } from 'semantic-ui-react'
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import DGTextbox from 'components/FormControls/Textbox/DGTextbox'
import GeneralMessage from 'components/GeneralMessage/GeneralMessage'
import fieldPasswordIcon from '../../assets/images/newui/field-password-icon.png'
import { setAuthState } from '../../store/actions/actions';
import servicegrace from '../../assets/images/newui/servicegrace.svg'
import next from '../../assets/images/newui/sellersignup/next-btn.svg'
import '../SignInContainer/SignInContainerNew.less'
import {pageView} from '../../common/analytics'

const initialState = {
    isLoading: false,
    existingPassword: '',
    password: '',
    confirmPassword: '',
    windowWidth: 0,
    message: '',
    messageType: 'error'
}
class PasswordChangeContainerNew extends Component {

    constructor(props) {
        super(props);
        this.state = initialState;
    }

    updateWindowDimensions = () => {
        this.setState({ windowWidth: window.innerWidth });
    }

    async componentDidMount() {
        pageView('/change-password', 'Change Password');

        const { loggedIn, currentUser, pageType } = this.props;

        if (!loggedIn || _.isEmpty(currentUser)) {

            //const response = await userContext();
            const response = await sellerContext();
            console.log(response);
            if (response && response.data) {
                this.props.setAuthState(true, response.data.user, '');
            }
            else {
                window.location = "/";
            }

        }

        this.updateWindowDimensions();
        window.addEventListener('resize', this.updateWindowDimensions);
        
    }

    handleChange = (e, { name, value }) => {
        this.setState({ [name]: value });
    }

    redirectToAppStore = () => {
        window.open('http://itunes.apple.com/app/id1481417514', '_blank');
    }

    onValidSubmit = async () => {

        try {
            const { existingPassword, password, confirmPassword } = this.state;
            const response = await changePassword({ existingPassword, password, confirmPassword });

            if (response.resStatus >= 400) {
                this.setState({ message: response.message || 'Password change failed.', messageType: "error" });

            } else {

                this.setState({ message: response.message || 'Password changed successfully.', messageType: "success", existingPassword: '', password: '', confirmPassword:'' });

            }
        } catch (error) {

        } finally {
            this.setState({ isLoading: false });
        }
    };
    redirectToSignIn = () => {
        this.props.history.push('/signin');
    }
    render() {
        const { message, messageType } = this.state

        return (this.props.loggedIn &&
            <React.Fragment>
       
<div className='small-form-container'>
                <img src={servicegrace} />
                <div className='small-form-heading'>ServiceGrace</div>
                <div className='small-form-sub-heading'>Change Password </div>
                {!_.isEmpty(this.state.message) && <GeneralMessage type={this.state.messageType} message={this.state.message} />}
                <Formsy onValidSubmit={this.onValidSubmit} className='small-form-form'>
                    <Grid>
                    <Grid.Column width={16} >
                                            <DGTextbox name="existingPassword" label="Existing Password" placeholder="" required type="password"
                                                tabIndex={4}
                                                icon={fieldPasswordIcon}
                                                maxLength={50}

                                                validationErrors={{
                                                    isDefaultRequiredValue: 'This field is required',
                                                }}
                                                value={this.state.existingPassword}
                                                onChange={this.handleChange}
                                            />


                                        </Grid.Column>

                                        <Grid.Column width={16} >
                                            <DGTextbox name="password" label="Password" placeholder="" required type="password"
                                                tabIndex={4}
                                                icon={fieldPasswordIcon}
                                                maxLength={50}
                                                validationErrors={{
                                                    isDefaultRequiredValue: 'This field is required',
                                                }}
                                                onChange={this.handleChange}
                                                value={this.state.password}
                                            />


                                        </Grid.Column>
                                        <Grid.Column width={16}>
                                            <DGTextbox name="confirmPassword" label="Confirm Password" placeholder="" required type="password"
                                                tabIndex={4}
                                                icon={fieldPasswordIcon}
                                                maxLength={50}
                                                validations={{
                                                    equalsField: 'password'
                                                }}
                                                validationErrors={{
                                                    isDefaultRequiredValue: 'This field is required',
                                                    equalsField: 'Both passwords must match.'

                                                }}
                                                onChange={this.handleChange}
                                                value={this.state.confirmPassword}
                                            />


                                        </Grid.Column>


                        
                        
                        <button className='small-form-submit' tabIndex={6} type='submit'>GO <img src={next} /></button>

                    </Grid>
                </Formsy>
            </div>
            </React.Fragment>
        )
    }
}

function mapStateToProps({ auth, seller }) {
    //Whatever is returned from this function will end up
    // as props inside of this container component
    
    return {
        loggedIn: auth.loggedIn,
        currentUser: auth.currentUser,
        loginError: auth.loginError,
        seller: seller
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        setAuthState,
        
    }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(PasswordChangeContainerNew);

